import React from "react";
import { useI18n } from "@/i18n";
import { Zap } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { t, lang, toggle } = useI18n();

  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background grid-noise flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute top-[-10%] left-[-5%] w-[500px] h-[500px] rounded-full bg-primary/10 blur-[120px]" />
      <div className="absolute bottom-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-accent/10 blur-[120px]" />

      <button
        data-testid="login-lang-toggle"
        onClick={toggle}
        className="absolute top-6 right-6 text-xs font-mono px-3 py-1.5 rounded-md border border-border text-muted-foreground hover:text-foreground transition-colors"
      >
        {lang === "en" ? "BM" : "EN"}
      </button>

      <div className="relative w-full max-w-md animate-float-up">
        <div className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center glow-amber">
            <Zap className="w-5 h-5 text-primary-foreground" fill="currentColor" />
          </div>
          <span className="font-display font-extrabold text-xl tracking-tight">AdsBoster<span className="text-primary"> AI</span></span>
        </div>

        <div className="bg-card border border-border rounded-2xl p-8 shadow-2xl">
          <h1 className="font-display text-2xl font-bold text-center mb-2">{t("login.title")}</h1>
          <p className="text-sm text-muted-foreground text-center mb-8">{t("login.sub")}</p>

          <button
            data-testid="google-login-button"
            onClick={handleGoogle}
            className="w-full flex items-center justify-center gap-3 bg-white text-slate-900 font-semibold py-3.5 rounded-xl hover:bg-slate-100 transition-colors"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {t("login.google")}
          </button>

          <p className="text-xs text-muted-foreground text-center mt-6">{t("login.secure")}</p>
        </div>

        <div className="text-center mt-6">
          <a href="/" data-testid="login-back-home" className="text-sm text-muted-foreground hover:text-foreground transition-colors">← Back to home</a>
        </div>
      </div>
    </div>
  );
}
